import React, { FC, useEffect, useState } from "react";

interface IInputFormProps {
    title: string;
    setResult: React.Dispatch<React.SetStateAction<number>>
}

const InputForm: FC<IInputFormProps> = ({ title, setResult}) => {
    const [a, setA] = useState<number>(0);
    const [b, setB] = useState<number>(0);
    const [c, setC] = useState<number>(0);

    const handleChangeA = (e: React.ChangeEvent<HTMLInputElement>) => {
        setA(parseFloat(e.target.value));
    };

    const handleChangeB = (e: React.ChangeEvent<HTMLInputElement>) => {
        setB(parseFloat(e.target.value));
    };

    const handleChangeC = (e: React.ChangeEvent<HTMLInputElement>) => {
        setC(parseFloat(e.target.value));
    };

    const getResult = (a: number, b: number, c: number) => {
        if (a !== undefined && b !== undefined && c !== undefined) {
            let result = a * b * c;
            setResult(result);
        } else {
            console.error('error')
        }
    };

    return (
        <div className="input__form">
            <div className="input__form-title">
                <p>{title}</p>
            </div>
            <div className="input__form-inputs">
                <input type="number" value={a} onChange={handleChangeA} id="first"/>
                <label htmlFor="first">м³</label>
                <input type="number" value={b} onChange={handleChangeB} />
                <label htmlFor="first">м³</label>
                <input type="number" value={c} onChange={handleChangeC} />
                <label htmlFor="first">м³</label>
            </div>
            <div className="input__form-error">
                <p style={{textAlign: 'center'}}>{a === 0 || b === 0 || c === 0 ? 'Cторона не может быть 0' : null}</p>
            </div>
            <div className="input__form-btn">
                <button onClick={() => getResult(a, b, c)}>Добавить данные для {title}</button>
            </div>
        </div>
    );
};

export default InputForm;
